import { create } from 'zustand';
import { INotificationStore } from './types';
import { notificationsApi } from '@/API';
import {
  ENotificationMeetingType,
  TNotificationCamel,
  TNotificationAppointmentsCamel,
  ENotificationActionType,
} from '@/types';
import { convertKeys } from '@/utils/common';

export const useNotificationsStore = create<INotificationStore>((set, get) => ({
  notifications: [],
  loading: false,
  getNotifications: async (institutionId) => {
    try {
      const res = await notificationsApi.getNotifications(institutionId);
      const notificationsCamel = convertKeys(res.data.data);
      set({
        notifications: notificationsCamel,
      });
    } catch (error) {
      console.error(error);
    }
  },
  getAppointmentNotifications: () => {
    return get().notifications.filter(
      (item): item is TNotificationAppointmentsCamel =>
        item.type !== ENotificationMeetingType.CHAT_REQUESTED,
    );
  },
  setNotification: (notification: TNotificationCamel) => {
    set((pr) => ({ notifications: [...pr.notifications, notification] }));
  },
  readAllNotifications: async () => {
    try {
      const ids = get()
        .notifications.filter(
          (item): item is TNotificationAppointmentsCamel =>
            item.type !== ENotificationMeetingType.CHAT_REQUESTED &&
            item.type !== ENotificationActionType.LOGOUT &&
            !item.readAt,
        )
        .map((filteredItem) => filteredItem.id);
      if (ids.length === 0) return;
      await notificationsApi.readNotifications(ids);
      set((pr) => ({
        ...pr,
        notifications: pr.notifications.map((notification) =>
          notification.type !== ENotificationActionType.LOGOUT &&
          notification.type !== ENotificationMeetingType.CHAT_REQUESTED
            ? {
                ...notification,
                readAt: notification.readAt ?? new Date().toISOString(),
              }
            : notification,
        ),
      }));
    } catch (error) {
      console.error(error);
    }
  },
  deleteNotifications: async () => {
    try {
      await notificationsApi.deleteNotifications();
      set({ notifications: [] });
    } catch (error) {
      console.error(error);
    }
  },
}));
